export const MOVE_RESIZE = 'MOVE_RESIZE'
export const CHANGE_IMAGE = 'CHANGE_IMAGE'
export const PUBLISH = 'PUBLISH'
export const EDIT_TEXT = 'EDIT_TEXT'
export const CROP = 'CROP'
export const EDIT_BULLET_POINTS = 'EDIT_BULLET_POINTS'
export const SCENES_DASHBOARD = 'SCENES_DASHBOARD'
export const SCENES_DASHBOARD_NEW = 'SCENES_DASHBOARD_NEW'
export const SCENES_DASHBOARD_EMPTY = 'SCENES_DASHBOARD_EMPTY'



// WEBPACK FOOTER //
// ./src/constants/shopifyWizardActions.js